<table td-data-table>
  <th *ngFor="let col of columns" td-data-table-column [numeric]="col.numeric">
    {{ col.displayName }}
  </th>
  <tbody *ngFor="let aggregation of stats.group.aggregations">
    <tr *ngFor="let rowData of aggregation.data" td-data-table-row>
      <td
        *ngFor="let cell of getCells(rowData)"
        td-data-table-cell
        [numeric]="cell.column.numeric"
        [ngClass]="cell.column.memberType"
      >
        <span *ngIf="!cell.column.customTemplate; else customTemplate">
          {{ cell.displayValue }}
        </span>
        <ng-template #customTemplate>
          <span *ngIf="cell.column.name === 'FlightLogId' && cell.value">
            <a routerLink="/flight-logs/{{ cell.value }}">View</a>
          </span>
        </ng-template>
      </td>
    </tr>
    <tr td-data-table-row class="totals-row">
      <td
        *ngFor="let cell of getCells(aggregation.totals)"
        td-data-table-cell
        [numeric]="cell.column.numeric"
      >
        <span *ngIf="cell.column.memberType === 'measure'">{{ cell.displayValue }}</span>
      </td>
    </tr>
  </tbody>
</table>
